<template>
  <div>
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <div class="mx-auto container-xl mb-5">
      <div class="">
        <div class="title-area">
          <h1 class="page-title h2 mb-5">
            My folders and groups
          </h1>
        </div>
      </div>
      <div class="survey-table">
        <div class="table-filter-area">
          <div class="mb-3">
            <input
              v-model="search"
              type="text"
              class="form-control"
              placeholder="Search"
              @input="handleSearch"
            />
          </div>
          <div class="d-flex justify-content-end">
            <router-link to="/create/group">
              <button type="button" class="btn btn-primary me-2 btn-small">
                <i class="fa fa-regular fa-plus me-2"></i>New group
              </button>
            </router-link>
            <button
              type="button"
              class="btn btn-primary btn-small"
              @click.prevent.stop="addNode(null, false, null)"
            >
              <i class="fa fa-regular fa-plus me-2"></i>New folder
            </button>
          </div>
        </div>
        <div class="flex-folders">
          <div class="flex-table">
            <div v-if="loading" class="text-center text-success my-2">
              <span class="spinner-border spinner-border-sm align-middle me-2" role="status" aria-hidden="true"></span>
              <strong>Loading...</strong>
            </div>
            <div>
              <table class="table mt-4 mb-0">
                <thead>
                  <tr>
                    <th scope="col"><span class="ps-3 ms-2">Folder</span></th>
                    <th scope="col"><span class="d-flex justify-content-end">Actions</span></th>
                  </tr>
                </thead>
              </table>
              <form class="d-inline" @submit.prevent="nullfunction">
                <Draggable
                  ref="folderTree"
                  v-model="nodes"
                  :indent="20"
                  :defaultOpen="false"
                  class="w-100 he-tree"
                  @change="onDragChange"
                  @before-drag-start="onBeforeDragStart"
                >
                  <template #default="{ node, stat }">
                    <div class="tree-row d-flex align-items-center" :class="{ 'is-editing': isEditing(node) }">
                      <span
                        v-if="(nodeType(node) === 2 || nodeType(node) === 0 || nodeType(node) === 3) && node.children && node.children.length > 0"
                        class="toggle-icon"
                        @click="toggleNode(stat)"
                      >
                        <i v-if="!stat.open" class="fa fa-regular fa-angle-down me-2" />
                        <i v-else class="fa fa-regular fa-angle-up me-2" />
                      </span>
                      <span v-else class="toggle-icon" />
                      <span class="item-icon">
                        <i v-if="nodeType(node) === 0" class="fa fa-regular fa-folder" />
                        <i v-else-if="nodeType(node) === 2" class="fa fa-regular fa-folder" />
                        <i
                          v-if="nodeType(node) === 1"
                          class="fa fa-regular fa-users group-clickable"
                          @click.prevent="group_setcurrent(node.data.group_id)"
                        />
                        <fa-icon v-if="nodeType(node) === 3" icon="trash-alt" />
                        <fa-icon v-if="nodeType(node) === 4" icon="folder" class="text-primary" />
                      </span>
                      <span
                        v-if="nodeType(node) === 0"
                        class="item-text"
                        :class="(node.data.group_deleted === 1) && muteclass"
                        @click="toggleNode(stat)"
                      >
                        <span v-if="!isEditing(node)">
                          {{ node.title }}
                        </span>
                        <input
                          v-else
                          v-model="editingnodename"
                          class="item-input"
                          placeholder="Type new name"
                          @keydown.stop
                          @keydown.esc="onNameEscape"
                          @keydown.enter.prevent="onNameEnter"
                        />
                      </span>
                      <span
                        v-else-if="nodeType(node) === 1"
                        class="item-text group-clickable"
                        :class="(node.data.group_deleted === 1) && muteclass"
                        @click.prevent="group_setcurrent(node.data.group_id)"
                      >
                        <span v-if="!isEditing(node)">
                          {{ node.title }}
                        </span>
                        <input
                          v-else
                          v-model="editingnodename"
                          class="item-input"
                          placeholder="Type new name"
                          @keydown.stop
                          @keydown.esc="onNameEscape"
                          @keydown.enter.prevent="onNameEnter"
                        />
                      </span>
                      <span v-else-if="nodeType(node) === 2" class="item-text">
                        {{ node.title }}
                      </span>
                      <span v-else-if="nodeType(node) === 3" class="item-text" @click="toggleNode(stat)">
                        {{ node.title }}
                      </span>
                      <div
                        v-if="isEditing(node)"
                        class="editing-toolbar d-flex align-items-center ms-auto"
                        @click.stop
                      >
                        <div v-if="nodeType(node) === 1" class="select-input me-2">
                          <select v-model="editingnodelanguage" class="form-select form-select-sm">
                            <option v-for="lang in languages" :key="lang.value" :value="lang.value">
                              {{ lang.text }}
                            </option>
                          </select>
                        </div>
                        <div v-if="nodeType(node) === 1" class="select-input me-2">
                          <select v-model="editingnodenorm" class="form-select form-select-sm">
                            <option v-for="norm in norm_values_options" :key="norm.value" :value="norm.value">
                              {{ norm.text }}
                            </option>
                          </select>
                        </div>
                        <button
                          v-if="node.data.isAdding"
                          type="button"
                          class="btn btn-danger btn-tiny me-2"
                          @click.prevent.stop="cancelAddNode"
                        >
                          Cancel
                        </button>
                        <button
                          v-if="!node.data.isAdding"
                          type="button"
                          class="btn btn-danger btn-tiny me-2"
                          @click.prevent.stop="resetEditNode"
                        >
                          Cancel
                        </button>
                        <button
                          v-if="node.data.isAdding"
                          type="button"
                          class="btn btn-primary btn-tiny"
                          @click.prevent.stop="saveAddNode"
                        >
                          Save
                        </button>
                        <button
                          v-if="!node.data.isAdding"
                          type="button"
                          class="btn btn-primary btn-tiny"
                          @click.prevent.stop="saveEditNode"
                        >
                          Save
                        </button>
                      </div>
                      <div
                        v-else-if="node.data.gdqtype !== 2"
                        class="ellipsis-button d-flex align-items-center ms-auto"
                        @click.stop
                      >
                        <BaseDropdown right variant="link">
                          <template #button-content>
                            <i class="fa-solid fa-ellipsis"></i>
                          </template>
                          <li>
                            <a class="dropdown-item" href="#" @click.prevent="startEditing(node)">Edit</a>
                          </li>
                          <li v-if="nodeType(node) === 0">
                            <a class="dropdown-item" href="#" @click.prevent="addNode(node, false, stat)">Create sub-folder</a>
                          </li>
                          <li v-if="canDeleteNode(node)">
                            <a class="dropdown-item" href="#" @click.prevent="requestDelete(node)">Delete</a>
                          </li>
                        </BaseDropdown>
                      </div>
                    </div>
                  </template>
                </Draggable>
              </form>
            </div>
          </div>
        </div>
        <BaseModal
          v-model="showDeleteModal"
          :title="deleteModalTitle"
          ok-title="Delete"
          ok-variant="danger"
          cancel-title="Cancel"
          @ok="confirmDelete"
        >
          {{ deleteModalMessage }}
        </BaseModal>
      </div>
    </div>
  </div>
</template>
<script>
import { computed, nextTick, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { Draggable } from '@he-tree/vue'
import '@he-tree/vue/style/default.css'
import BaseDropdown from '../base/BaseDropdown.vue'
import BaseModal from '../base/BaseModal.vue'
import Breadcrumb from '../Breadcrumb.vue'
import Navbar from '../Navbar.vue'

export default {
  components: {
    Navbar,
    Breadcrumb,
    Draggable,
    BaseDropdown,
    BaseModal
  },
  props: {
    surveytype: {
      type: String,
      default: ''
    }
  },
  setup () {
    const store = useStore()
    const router = useRouter()

    const search = ref('')
    const treeKey = ref(0)
    const dragSourceData = ref(null)
    const editingnode = ref(null)
    const editingnodename = ref('')
    const editingnodelanguage = ref(null)
    const editingnodenorm = ref(null)
    const addingnodeto = ref(null)
    const nodes = ref([])
    const items = ref([])
    const loading = ref(true)
    const languages = ref([])
    const showDeleteModal = ref(false)
    const pendingDelete = ref({ groupId: null, folderId: null, type: null })
    const screentexts = ref([])
    const screen_id = ref(1)
    const total = ref(0)
    const retrieved = ref(0)
    const muteclass = 'text-muted'
    const folderTree = ref(null)
    const lastExpandedFolderId = ref(null)
    const pendingOpenFolderIds = ref(null)
    let searchTimeout = null

    const norm_values_options = computed(() => {
      const items = store.state.normvalues_countries || []
      const options = [{ value: 0, text: 'Please select norm values' }]
      for (let i = 0; i < items.length; i++) {
        const option = {
          value: items[i].country_id,
          text: items[i].country_name
        }
        options.push(option)
      }
      return options
    })

    const handleSearch = () => {
      if (searchTimeout) {
        clearTimeout(searchTimeout)
      }
      searchTimeout = setTimeout(() => {
        groups_get()
      }, 1000)
    }

    const nullfunction = function () {
      return true
    }

    const screentexts_get = function () {
      const textCollection = []
      const filter = {
        screen_id: {
          operator: '=',
          value: screen_id.value
        }
      }
      store.dispatch('systemscreenelements_fetch', { filter })
        .then((resp) => {
          const dbtexts = resp.data.result || []
          for (let i = 0; i < dbtexts.length; i++) {
            const screentext = {
              id: dbtexts[i].id,
              element_text: dbtexts[i].element_text,
              element_bubbletext: dbtexts[i].element_bubbletext
            }
            textCollection[dbtexts[i].id] = screentext
          }
          screentexts.value = textCollection
        })
    }

    const isEditing = (node) => {
      return Boolean(
        editingnode.value &&
        node &&
        node.data &&
        editingnode.value.data &&
        editingnode.value.data.folder_id === node.data.folder_id &&
        editingnode.value.data.group_id === node.data.group_id
      )
    }

    const resetEditNode = () => {
      editingnode.value = null
      editingnodename.value = ''
      editingnodelanguage.value = null
      editingnodenorm.value = null
    }

    const resetAddNode = () => {
      addingnodeto.value = null
      resetEditNode()
    }

    const startEditing = (node) => {
      if (!node || !node.data) {
        return
      }
      if (editingnode.value && editingnode.value.data && editingnode.value.data.isAdding) {
        cancelAddNode()
      } else {
        resetEditNode()
      }
      editingnode.value = node
      editingnodename.value = node.title
      editingnodelanguage.value = node.data.language_id ?? null
      editingnodenorm.value = node.data.normvalues_id ?? null
    }

    const addNode = (node, isLeaf = false, stat = null) => {
      const target = node || null
      if (editingnode.value && editingnode.value.data && editingnode.value.data.isAdding) {
        cancelAddNode()
      } else {
        resetEditNode()
      }

      const parentId = target && target.data ? target.data.folder_id : 0

      const now = Date.now()
      const newNode = {
        title: 'New folder',
        isLeaf,
        data: {
          gdqtype: 0,
          folder_id: now,
          group_id: now,
          parent_id: parentId,
          isAdding: true
        },
        children: [],
        isSelectable: false,
        isDraggable: false
      }

      if (target) {
        if (!target.children) {
          target.children = []
        }
        target.children = [...target.children, newNode]
        nodes.value = [...nodes.value]
      } else {
        const list = nodes.value || []
        nodes.value = [...list, newNode]
      }

      addingnodeto.value = target
      editingnode.value = newNode
      editingnodename.value = newNode.title
      editingnodelanguage.value = null
      editingnodenorm.value = null

      if (target && target.data) {
        const targetFolderId = Number(target.data.folder_id)
        nextTick(() => {
          openFolderById(targetFolderId)
        })
      }
    }

    const cancelAddNode = () => {
      if (addingnodeto.value && addingnodeto.value.children && editingnode.value) {
        const idx = addingnodeto.value.children.indexOf(editingnode.value)
        if (idx !== -1) {
          addingnodeto.value.children.splice(idx, 1)
        }
      } else if (!addingnodeto.value && editingnode.value) {
        const idx = nodes.value.indexOf(editingnode.value)
        if (idx !== -1) {
          nodes.value.splice(idx, 1)
        }
      }
      resetAddNode()
    }

    const onNameEscape = () => {
      if (editingnode.value && editingnode.value.data && editingnode.value.data.isAdding) {
        cancelAddNode()
      } else {
        resetEditNode()
      }
    }

    const onNameEnter = () => {
      if (editingnode.value && editingnode.value.data && editingnode.value.data.isAdding) {
        saveAddNode()
      } else {
        saveEditNode()
      }
    }

    const saveAddNode = () => {
      if (!editingnode.value) {
        return
      }
      const parentId = editingnode.value.data.parent_id
      const newfolder = {
        folder_name: editingnodename.value,
        parent_id: parentId
      }
      if (parentId) {
        lastExpandedFolderId.value = parentId
      }
      store.dispatch('folder_create', { folder: newfolder })
        .then(() => {
          resetAddNode()
          groups_get()
        })
    }

    const saveEditNode = () => {
      const node = editingnode.value
      if (!node || !node.data) {
        return
      }
      if (nodeType(node) === 0) {
        const folder = {
          id: node.data.folder_id,
          folder_name: editingnodename.value
        }
        store.dispatch('folder_save', { folder })
          .then(() => {
            resetEditNode()
            groups_get()
          })
      } else if (nodeType(node) === 1) {
        const group = {
          id: node.data.group_id,
          group_name: editingnodename.value,
          group_language_id: editingnodelanguage.value,
          group_normvalues_id: editingnodenorm.value
        }
        store.dispatch('group_save', { group })
          .then(() => {
            store.dispatch('mygdqpage_setreload', { reload: 1 })
            resetEditNode()
            groups_get()
          })
      }
    }

    const toggleNode = (stat) => {
      if (stat) {
        stat.open = !stat.open
      }
    }

    const requestDelete = (node) => {
      if (!node || !node.data || !canDeleteNode(node)) {
        return
      }
      pendingDelete.value = {
        groupId: node.data.group_id,
        folderId: node.data.folder_id,
        type: nodeType(node)
      }
      showDeleteModal.value = true
    }

    const confirmDelete = () => {
      const { groupId, folderId, type } = pendingDelete.value
      if (groupId === null && folderId === null) {
        showDeleteModal.value = false
        return
      }
      if (type === 0 && (!folderId || Number(folderId) <= 0)) {
        showDeleteModal.value = false
        pendingDelete.value = { groupId: null, folderId: null, type: null }
        return
      }

      const group = {
        id: groupId,
        group_folder_id: -1,
        group_deleted: 1
      }
      const folder = {
        id: folderId,
        parent_id: -1,
        folder_deleted: 1
      }
      const body = {
        group,
        folder,
        type
      }

      let id = 0
      if (type === 0) {
        id = folderId
      }
      if (type === 1) {
        id = groupId
      }

      store.dispatch('treeitem_save', { id, body })
        .then(() => {
          groups_get()
        })

      showDeleteModal.value = false
      pendingDelete.value = { groupId: null, folderId: null, type: null }
    }

    const onBeforeDragStart = (stat) => {
      console.log('[drag] beforeDragStart', stat)
      dragSourceData.value = stat ? stat.data : null
      pendingOpenFolderIds.value = getOpenFolderIds()
    }

    const onDragChange = () => {
      console.log('[drag] onChange, sourceData=', dragSourceData.value)
      const sourceData = dragSourceData.value
      dragSourceData.value = null

      if (!sourceData) return

      const tree = folderTree.value
      if (!tree) return

      const draggedStat = tree.getStat(sourceData)
      console.log('[drag] draggedStat=', draggedStat, 'parent=', draggedStat?.parent)
      if (!draggedStat || !draggedStat.data) return

      const parentStat = draggedStat.parent
      const parentData = parentStat ? parentStat.data?.data : null

      console.log('[drag] parentData=', parentData)

      if (parentData && (Number(parentData.gdqtype) === 1 || Number(parentData.gdqtype) === 4)) {
        return
      }

      const gdqtype = Number(draggedStat.data.data.gdqtype)
      const group_id = draggedStat.data.data.group_id
      const folder_id = draggedStat.data.data.folder_id
      const to_folder_id = parentData ? parentData.folder_id : 0
      const group_deleted = parentData && Number(parentData.gdqtype) === 3 ? 1 : 0
      const folder_deleted = parentData && Number(parentData.gdqtype) === 3 ? 1 : 0
      const group = {
        id: group_id,
        group_folder_id: to_folder_id,
        group_deleted
      }
      const folder = {
        id: folder_id,
        parent_id: to_folder_id,
        folder_deleted
      }
      const body = {
        group,
        folder,
        type: gdqtype
      }
      let id = 0
      if (gdqtype === 0) {
        id = folder_id
      }
      if (gdqtype === 1) {
        id = group_id
      }

      const openIds = pendingOpenFolderIds.value || []
      if (to_folder_id && !openIds.includes(to_folder_id)) {
        openIds.push(to_folder_id)
      }
      pendingOpenFolderIds.value = openIds

      store.dispatch('treeitem_save', { id, body })
        .then(() => {
          groups_get()
        })
    }

    const closeAllNodes = () => {
      const tree = folderTree.value
      if (tree && tree.processor && typeof tree.processor.closeAll === 'function') {
        tree.processor.closeAll()
      }
    }

    const groups_get = function () {
      loading.value = true
      store.dispatch('foldertree_fetch', { type: 'new', search: search.value, drag: 1 })
        .then(() => {
          items.value = store.state.foldertree.data || []
          total.value = store.state.foldertree.total || 0
          normalizeNodeTypes(items.value)
        }).then(() => {
          if (search.value) {
            const data = Array.isArray(items.value) ? [...items.value] : []
            nodes.value = data
            retrieved.value = data.length
          } else {
            const structured = restructureItems(items.value)
            nodes.value = structured
          }
          loading.value = false
          nextTick(() => {
            closeAllNodes()
            if (pendingOpenFolderIds.value !== null) {
              pendingOpenFolderIds.value.forEach(fid => openFolderById(fid))
              pendingOpenFolderIds.value = null
            } else if (lastExpandedFolderId.value !== null) {
              openFolderById(lastExpandedFolderId.value)
              lastExpandedFolderId.value = null
            }
          })
        })
    }

    const restructureItems = (list) => {
      const items = Array.isArray(list) ? [...list] : []

      const newTopLevelObject = {
        title: 'No folder',
        data: {
          gdqtype: 2,
          gdqindex: 203203203,
          folder_id: 0,
          group_id: 0,
          parent_id: 0
        },
        children: [],
        isDraggable: false,
        isExpanded: false,
        isLeaf: false,
        isSelectable: false,
        open: false
      }

      const modifiedItems = items.filter(item => {
        if ((!item.children || item.children.length === 0) && item.isLeaf) {
          newTopLevelObject.children.push(item)
          return false
        }
        return true
      })

      modifiedItems.unshift(newTopLevelObject)

      if (modifiedItems.length === 1) {
        retrieved.value = modifiedItems.length
      } else {
        retrieved.value = modifiedItems.length - 1
      }

      return modifiedItems
    }

    const nodeType = (node) => {
      return Number(node && node.data && node.data.gdqtype !== undefined ? node.data.gdqtype : 0)
    }

    const canDeleteNode = (node) => {
      if (!node || !node.data) {
        return false
      }
      const type = nodeType(node)
      if (type === 1) {
        return true
      }
      if (type === 0) {
        return Number(node.data.folder_id) > 0
      }
      return false
    }

    const openFolderById = (folderId) => {
      const tree = folderTree.value
      if (!tree || !tree.processor || !Array.isArray(tree.processor.statsFlat)) return
      const targetStat = tree.processor.statsFlat.find(s => {
        const d = s.data?.data
        return d && Number(d.gdqtype) === 0 && Number(d.folder_id) === Number(folderId)
      })
      if (targetStat) {
        tree.processor.openNodeAndParents(targetStat)
      }
    }

    const getOpenFolderIds = () => {
      const tree = folderTree.value
      if (!tree || !tree.processor || !Array.isArray(tree.processor.statsFlat)) return []
      return tree.processor.statsFlat
        .filter(s => s.open && s.data?.data && Number(s.data.data.gdqtype) === 0)
        .map(s => Number(s.data.data.folder_id))
    }

    const collapseAll = (list) => {
      if (!Array.isArray(list)) {
        return
      }
      list.forEach(node => {
        if (!node) return
        node.open = false
        node.isExpanded = false
        if (Array.isArray(node.children)) {
          collapseAll(node.children)
        }
      })
    }

    const normalizeNodeTypes = (list) => {
      if (!Array.isArray(list)) {
        return
      }
      list.forEach(node => {
        if (node && node.data) {
          node.data.gdqtype = Number(node.data.gdqtype)
          node.data.folder_id = Number(node.data.folder_id)
          node.data.group_id = Number(node.data.group_id)
          node.data.parent_id = Number(node.data.parent_id)
        }
        if (node) {
          node.isExpanded = false
          node.open = false
        }
        if (node && Array.isArray(node.children)) {
          normalizeNodeTypes(node.children)
        }
      })
    }

    const group_setcurrent = function (group_id) {
      store.dispatch('group_setcurrent', group_id)
      router.push('/group')
    }

    const languages_get = () => {
      store.dispatch('languages_fetch')
        .then((resp) => {
          languages.value = resp.data.result.map(l => {
            return {
              value: l.id,
              text: l.language_name
            }
          })
        })
    }

    const deleteModalTitle = computed(() => {
      if (pendingDelete.value.type === 0) {
        return 'Delete folder'
      }
      if (pendingDelete.value.type === 1) {
        return 'Delete group'
      }
      return 'Delete item'
    })

    const deleteModalMessage = computed(() => {
      if (pendingDelete.value.type === 0) {
        return 'Are you sure you want to delete this folder?'
      }
      if (pendingDelete.value.type === 1) {
        return 'Are you sure you want to delete this group? All surveys for the group will also be deleted.'
      }
      return 'Are you sure you want to delete this item?'
    })

    onMounted(() => {
      groups_get()
      screentexts_get()
      languages_get()
    })

    return {
      folderTree,
      search,
      editingnode,
      editingnodename,
      editingnodelanguage,
      editingnodenorm,
      addingnodeto,
      nodes,
      items,
      loading,
      languages,
      screentexts,
      screen_id,
      total,
      retrieved,
      muteclass,
      showDeleteModal,
      deleteModalTitle,
      deleteModalMessage,
      // Computed
      norm_values_options,
      // Methods
      handleSearch,
      nullfunction,
      screentexts_get,
      isEditing,
      resetEditNode,
      resetAddNode,
      startEditing,
      addNode,
      nodeType,
      cancelAddNode,
      onNameEscape,
      onNameEnter,
      saveAddNode,
      saveEditNode,
      toggleNode,
      requestDelete,
      confirmDelete,
      onBeforeDragStart,
      onDragChange,
      groups_get,
      restructureItems,
      group_setcurrent,
      languages_get,
      canDeleteNode
    }
  }
}
</script>
<style>
td {
  cursor: pointer !important;
}

/* Override he-tree default styles to match sl-vue-tree appearance */
.he-tree {
  list-style: none;
  padding: 0;
  font-size: 16px !important;
}

.he-tree ul {
  list-style: none;
  padding-left: 0;
}

.he-tree li {
  list-style: none;
}

.he-tree .tree-node-inner {
  width: 100%;
}

.tree-row {
  padding: 0.5rem 0;
  cursor: pointer;
  width: 100%;
  position: relative;
  font-size: 16px;
  font-weight: 400;
  border-top: 1px solid #dee2e6;
}

.tree-row:hover {
  color: #222222;
}

/* Remove all table borders to avoid double line */
.survey-table .table,
.survey-table .table thead,
.survey-table .table thead tr,
.survey-table .table thead th {
  border: none !important;
  border-bottom: none !important;
}

.toggle-icon {
  display: inline-block;
  width: 20px;
  cursor: pointer;
  margin-right: 0.5rem;
}

.item-icon {
  display: inline-block;
  margin-right: 4px;
  font-size: 1.1em !important;
}

.item-text {
  font-size: 16px !important;
  font-weight: 400;
  flex: 1;
  cursor: pointer;
  line-height: 1.4;
}

.item-input {
  border: 0 !important;
  padding: 0 !important;
  color: #007d8f;
  margin-left: 4px;
  height: 19px;
  margin-bottom: 4px;
  font-size: 1em !important;
  background: transparent;
  outline: none;
  width: 100%;
}

.tree-row.is-editing {
  background-color: #E4F1F4;
}

.group-clickable {
  cursor: pointer;
}

.ellipsis-button {
  margin-left: auto;
}

.ellipsis-button .btn-link {
  text-decoration: none;
  color: inherit;
  padding: 0;
}

.ellipsis-button .btn-link:hover {
  text-decoration: none;
  color: inherit;
}

.ellipsis-button .btn-link:focus {
  box-shadow: none;
}

.editing-toolbar .form-select {
  min-width: 150px;
}

.editing-toolbar {
  padding-left: 2.5rem;
}

/* Hide he-tree's default fold button since we're using our own toggle */
.he-tree .tree-node-inner .fold-button {
  display: none !important;
}

/* Drag-and-drop visual feedback */
.he-tree-drag-placeholder {
  background: rgba(0, 125, 143, 0.12) !important;
  border: 2px dashed #007d8f !important;
  height: 30px !important;
  border-radius: 4px;
  margin: 2px 0;
}

.he-tree .dragging-node .tree-row {
  opacity: 0.35;
}

.he-tree.drag-overing .tree-row:not(.is-editing):hover {
  background-color: rgba(0, 125, 143, 0.08);
  border-radius: 4px;
}

.survey-table {
  padding-bottom: 2rem;
}
</style>
